import { Component, OnInit } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { PolicyService } from '@core/services/policy.service';
import { BaseModuleComponent } from '@modules/base-module/base-module.component';
import { PolicyStates } from '@shared/models/codebooks/policy-state';
import { Lob } from '@shared/models/lob-enum';
import { User } from '@shared/models/user';

@Component({
    selector: 'app-policies',
    template: '',
    styleUrls: [],
    standalone: false
})
export class PoliciesComponent extends BaseModuleComponent implements OnInit {

  public loggedUser: User;

  readonly lob: typeof Lob = Lob;
  readonly startDate: Date;
  readonly endDate: Date;
  readonly policyStates: PolicyStates;


  constructor(
    public commonService: CommonService,
    protected dataService: DataService,
    protected policyService: PolicyService
  ) {
    super(commonService);
    this.loggedUser = this.getLoggedUser();
    this.policyStates = this.dataService.policyStates;
   }

  ngOnInit(): void {

  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }

}
